enum Environment {
  LOCAL,
  DEV,
  STA,
  PROD
}

export const getEnvironment = (): Environment => {
  const hostname = window.location.hostname;

  if (hostname.endsWith(".herokuapp.com")) {
    if (hostname.includes("avvio-cedoon-portal-dev")) {
      return Environment.DEV;
    } else if (hostname.includes("avvio-cedoon-portal-sta")) {
      return Environment.STA;
    } else if (hostname.includes("avvio-cedoon-portal.herokuapp.com")) {
      return Environment.PROD;
    }
  } else if (hostname.includes("member.cedoon.org")) {
    return Environment.PROD;
  }
  return Environment.LOCAL;
};

export const getEndpointByGuessing = (): string => {
  switch (getEnvironment()) {
    case Environment.DEV:
      return "https://dev-cedoon-api.herokuapp.com/graphql";
    case Environment.LOCAL:
      return "http://localhost:3000/graphql";
    case Environment.STA:
      return "https://sta-cedoon-api.herokuapp.com/graphql";
    case Environment.PROD:
      return "https://cedoon-api.herokuapp.com/graphql";
    default:
      return "http://localhost:3000/graphql";
  }
};

export const isDevOrLocalEnvironment = (): boolean => {
  const env = getEnvironment();
  return env === Environment.DEV || env === Environment.LOCAL;
};
